import React, { useEffect, useState } from 'react';
import {
  Card,
  CardText,
  CardTitle,
  SelectField,
  Cell,
  Grid,
  TextField,
  Button,
  Checkbox
} from "react-md";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { colorsArray,evaluateOptions,QueryOptions } from "./commonHelpers";
import copyIcon from '../../images/png/copy.png';
import crossIcon from '../../images/png/crossIcon.png';
import plusIcon from '../../images/png/plus.png';
import LabelPositionFields from './LabelPositionFields';
import ColorPickerField from './ColorPickerField';
const DrawVectorAnswerOption = ({ data, key, classNameString, onValueChange }) => {
  const [xEvaluateAdd,setXEvaluteAdd] = useState(data?.xAddFormulaSwitch ? data?.xAddFormulaSwitch :false)
  const [yEvaluateAdd,setYEvaluteAdd] = useState(data?.yAddFormulaSwitch ? data?.yAddFormulaSwitch :false)
  const [magEvaluateAdd,setMagEvaluteAdd] = useState(data?.magAddFormulaSwitch ? data?.magAddFormulaSwitch :false)
  const [angEvaluateAdd,setAngEvaluteAdd] = useState(data?.angAddFormulaSwitch ? data?.angAddFormulaSwitch :false)
  if (!data) {
    return null;
  }
  const {
    name,
    formulaType,
    angleFormula,
    magFormula,
    xFormula,
    yFormula,
    showLabel,
    labelPositionType,
    labelPositionX,
    labelPositionY,
    formulaColor,
    showImage,
    showComponents,
    showAngle,
    autoOrigin,
    evaluate_x,
    evaluate_y,
    xOrigin,
    yOrigin,
    posX,
    posY,
    xEvaluateOption,
    xQueryOption,
    xAddFormulaSwitch,
    xEvaluateOptionTwo,
    xFormulaTwo,
    yEvaluateOption,
    yQueryOption,
    yEvaluateOptionTwo,
    yFormulaTwo,
    yAddFormulaSwitch,
    evaluate_magnitue,
    magEvaluateOption,
    magAddFormulaSwitch,
    magQueryOption,
    magEvaluateOptionTwo,
    magFormulaTwo,
    evaluate_angle,
    angEvaluateOption,
    angAddFormulaSwitch,
    angQueryOption,
    angEvaluateOptionTwo,
    angFormulaTwo,
    isIncorrectAnswer,
    isStaticVector
  
  } = data;
  let help_text = { 
    _x: "\\vec{A}_x + \\vec{B}_x ",
    _y: "\\vec{A}_y + \\vec{B}_y",
    _mag: "sqrt((\\vec{A}_mag*cos(\\vec{A}_ang))^2)",
    _ang: "atan(sin(\\vec{A}_ang)/cos(\\vec{A}_ang))"

     }
  const onChange = (name, value) => {
    const tempData = { ...data };
    tempData[name] = value;
    onValueChange(tempData);
  };
  const onXEvaluateAdd = () => {

    setXEvaluteAdd(!xEvaluateAdd)
    onChange("xAddFormulaSwitch",!xEvaluateAdd)
  };
  const onMagEvaluateAdd = () => {

    setMagEvaluteAdd(!magEvaluateAdd)
    onChange("magAddFormulaSwitch",!magEvaluateAdd)
  };
  const onAngEvaluateAdd = () => {

    setAngEvaluteAdd(!angEvaluateAdd)
    onChange("angAddFormulaSwitch",!angEvaluateAdd)
  };
  const onYEvaluateAdd = () => {

    setYEvaluteAdd(!yEvaluateAdd)
    onChange("yAddFormulaSwitch",!yEvaluateAdd)
  };
  return (
    <div className={classNameString} key={key} style={{ marginLeft: "0px" }}>
    
      <CardText>

            <Grid style={{ marginLeft: "0px" }}>
              <Cell  size={2} >
                <TextField
                  id={`vector-name-${name}`}
                  className="textFieldClass"
                  value={name.trimStart()}
                  label="Name"
                  errorText="Name field cannot be empty"
                  required={true}
                  onChange={(value) => {
                    onChange("name", value);
                  }}
                />
              </Cell>
              <Cell  size={2}>
                  <label
                          htmlFor={`static-vector-check-${name}`}
                          className="vectors-toggle-label"
                        >
                          {"Given Vector"}
                        </label>
                        <Toggle
                          icons={false}
                          width={230}
                      id={`static-vector-check-${name}`}
                      name="Given Vector"
                      onChange={(event) => {
                        if(event.target.checked) {
                          onChange("xEvaluateOption", 0);
                          onChange("yEvaluateOption", 0);
                          setXEvaluteAdd(false)
                          onChange("xAddFormulaSwitch",false)
                          setYEvaluteAdd(false)
                          onChange("yAddFormulaSwitch",false)
                        }
                        onChange("isStaticVector", event.target.checked);
                      }}
                      checked={isStaticVector}
                      className="rp-fraction-checkbox"
                      label="Given Vector"
                    />
              </Cell>
              {!isStaticVector ?
              <Cell  size={2}>
                    <label
                            htmlFor={`incorrect-answer-check-${name}`}
                            className="vectors-toggle-label"
                          >
                            {"Incorrect Answer"}
                          </label>
                          <Toggle
                            icons={false}
                            width={230}
                        id={`incorrect-answer-check-${name}`}
                        name="Incorrect Answer"
                        onChange={(event) => {
                          onChange("isIncorrectAnswer", event.target.checked);
                        }}
                        checked={isIncorrectAnswer}
                        className="rp-fraction-checkbox"
                        label="Incorrect Answer"
                      />
                    </Cell> : ""
              }
              { !isIncorrectAnswer || isStaticVector ?
               <React.Fragment>
                
                <Cell size={3}>
                  <SelectField
                    id={`vector-formula-${name}`}
                    label="Formula Type"
                    onChange={(value) => {
                      onChange("formulaType", value);
                    }}
                    name="formulaType"
                    menuItems={["components", "angle-magnitude"]}
                    value={formulaType}
                  />
                </Cell>
                <Cell size={3}>
                  <ColorPickerField 
                  value={formulaColor}
                  onChange={(value) => {
                      onChange("formulaColor", value);
                  }}
                />
                {/* <SelectField
                  helpText="Answer Arrow Color"
                  id={`text-color-answer-${name}`}
                  label="Color"
                  onChange={(value) => {
                    // variableObj.color = value;
                    onChange("formulaColor", value);
                  }}
                  menuItems={colorsArray}
                  value={formulaColor}
                /> */}
                </Cell>
                <React.Fragment>
                <Cell  size={2}>
                      <TextField
                        id={`x-Origin-vector-${name}`}
                        disabled={autoOrigin}
                        className="textFieldClass"
                        type="number"
                        value={autoOrigin ? posX:xOrigin}
                        label="origin-x"
                        onChange={(value) => {
                          onChange("xOrigin", value);
                        }}
                        helpText="x component of vector"
                      />
                </Cell>
                <Cell  size={2}>
                      <TextField
                        id={`y-Origin-vector-${name}`}
                        disabled={autoOrigin}
                        className="textFieldClass"
                        type="number"
                        value={autoOrigin ? posY:yOrigin}
                        label="origin-y"
                        onChange={(value) => {
                          onChange("yOrigin", value);
                        }}
                        helpText="y component of vector"
                      />
                </Cell>
                </React.Fragment>
                <Cell  size={2}>
                <label
                        htmlFor={`auto-origin-check-${name}`}
                        className="vectors-toggle-label"
                      >
                        {"Auto Origin"}
                </label>
                  <Toggle
                        icons={false}
                        width={230}
                    id={`auto-origin-check-${name}`}
                    name="Auto Origin"
                    onChange={(event) => {
                      onChange("autoOrigin", event.target.checked);
                    }}
                    checked={autoOrigin}
                  />
                </Cell>
                <Cell  size={1}>
                <label
                        htmlFor={`show-label-check-${name}`}
                        className="vectors-toggle-label"
                      >
                        {"Show Label"}
                      </label>
                      <Toggle
                        icons={false}
                        width={230}
                    id={`show-label-check-${name}`}
                    name="Show Label"
                    onChange={(event) => {
                      onChange("showLabel", event.target.checked);
                    }}
                    checked={showLabel}
                  />
                </Cell>
                  
                <LabelPositionFields 
                    id={name}
                    showLabel={showLabel}
                    type={labelPositionType ? labelPositionType : "Automatic"}
                    onTypeChange={(newValue) => {
                        onChange("labelPositionType", newValue);
                    }}
                    xValue={labelPositionX ? labelPositionX : posX}
                    onXValueChange={(newValue) => {
                        onChange("labelPositionX", newValue);
                    }}
                    yValue={labelPositionY ? labelPositionY : posY}
                    onYValueChange={(newValue) => {
                        onChange("labelPositionY", newValue);
                    }}
                  />

                <Cell  size={1}>
                <label
                        htmlFor={`show-angle-check-${name}`}
                        className="vectors-toggle-label"
                      >
                        {"Show Angle"}
                      </label>
                      <Toggle
                        icons={false}
                        width={230}
                    id={`show-angle-check-${name}`}
                    name="Show Angle"
                    onChange={(event) => {
                      onChange("showAngle", event.target.checked);
                    }}
                    checked={showAngle}
                    className="rp-fraction-checkbox"
                    label="Show Angle"
                  />
                </Cell>
                {/* <Cell  size={1}>
                <label
                        htmlFor={`show-image-check-${name}`}
                        className="vectors-toggle-label"
                      >
                        {"Show Image"}
                      </label>
                      <Toggle
                        icons={false}
                        width={230}
                    id={`show-image-check-${name}`}
                    name="Show Image"
                    onChange={(event) => {
                      onChange("showImage",event.target.checked);
                    }}
                    checked={showImage}
                  />
                </Cell> */}

                <Cell  size={2}>
                <label
                        htmlFor={`show-components-check-${name}`}
                        className="vectors-toggle-label"
                      >
                        {"Show Components"}
                      </label>
                      <Toggle
                        icons={false}
                        width={230}
                    id={`show-components-check-${name}`}
                    name="Show Components"
                    onChange={(event) => {
                      onChange("showComponents", event.target.checked);
                    }}
                    checked={showComponents}
                  />
                </Cell>
                {formulaType === "components" ? (
                  <React.Fragment>
                    <Cell size={xEvaluateAdd ? 12 : !isStaticVector  ? 6 :5} style={{padding:"0px"}} >

                      <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>

                      <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                        <label
                                className="vectors-toggle-label"
                              > 
                              <div  style={{ display: "flex",textWrap: "nowrap" ,fontSize:"12px",marginTop:xEvaluateAdd ? "50%" :"60%"}}>
                                <div >
                                Evaluate X
                                </div>
                                {/* <div>
                                  <Button
                                    className="nocqcStyle"
                                    icon
                                    tooltipLabel="Evaluates only the X component of the answer drawn by the student and ignores the Y component."
                                  >
                                    help
                                  </Button>
                                </div> */}
                              </div>   
                        </label>
                          <Toggle
                                icons={false}
                                width={230}
                                defaultChecked={
                                  evaluate_x ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                }
                            id={`auto-origin-check-${name}`}
                            name="evaluate_x"
                            onChange={(event) => {
                              onChange("evaluate_x", !event.target.checked ? 1 : 0);
                            }}
                            checked={evaluate_x === 1 ? false :true}
                          />
                      </Cell>
                      <Cell size={xEvaluateAdd ? 2 : !isStaticVector  ? 3 :4} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                        <div style={{display:"flex",height:"100%"}}>
                            
                            <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                            <label
                                className="vectors-toggle-label"
                              > 
                                <div style={{marginTop: xEvaluateAdd ? "66%" :"100%",fontSize:"12px"}}>
                                  X comp
                                </div>
                              </label>
                              </div>   
                            <div style={{paddingLeft:"10px"}}>

                              <SelectField
                                  helpText="Select"
                                  defaultValue={0}
                                  disabled={isStaticVector}
                                  style={{marginTop:xEvaluateAdd ? "33%" :"49%"}}
                                  id={`text-color-answer-${name}`}
                                  onChange={(value) => {
                                    onChange("xEvaluateOption", value);
                                  }}
                                  menuItems={evaluateOptions}
                                  value={isStaticVector ? 0 :xEvaluateOption}
                                />
                            </div>
                        </div>

                      </Cell>
                      <Cell size={xEvaluateAdd ? 3 : !isStaticVector  ? 4 : 5} style={{borderRight: !isStaticVector ? "1px solid #9F9F9F" :"",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                          <TextField
                            id={`x-Formula-vector-${name}`}
                            className="textFieldClass"
                            rows={1}
                            value={xFormula}
                            label="x value"
                            onChange={(value) => {
                              onChange("xFormula", value);
                            }}
                          />
                        </Cell>
                        {!xEvaluateAdd  && !isStaticVector ? 
                                      <Cell size={2} style={{margin:"0px"}}>
                                              <Button 
                                              className="sm-cell--left"
                                              style={{ width:"65px",marginLeft:"5px",marginTop:"25%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                              flat 
                                              onClick={()=> onXEvaluateAdd()}>
                                                
                                              Add
                                              another
                                              X
                                              Condition
                                              </Button>
                                      </Cell> : !isStaticVector ?   
                                      <React.Fragment>

                                      <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                        <SelectField
                                            helpText="Select"
                                            id={`x-Formula-vector-${name}`}
                                            className="textFieldClass"
                                            onChange={(value) => {
                                              // variableObj.color = value;
                                              onChange("xQueryOption", value);
                                            }}
                                            style={{marginTop:"25%",paddingRight:"10px"}}
                                            menuItems={QueryOptions}
                                            value={xQueryOption}
                                            defaultValue={0}
                                          />
                                    </Cell>
                                        <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                            <SelectField
                                                helpText="Select"
                                                style={{marginTop:"35%",marginLeft:"10px"}}
                                                id={`text-color-answer-${name}`}
                                                onChange={(value) => {
                                                  // variableObj.color = value;
                                                  onChange("xEvaluateOptionTwo", value);
                                                }}
                                                defaultValue={0}
                                                menuItems={evaluateOptions}
                                                value={xEvaluateOptionTwo}
                                              />
                                        </Cell>
                                    <Cell size={3} style={{marginLeft:"30px"}}>    
                                      <div style={{display:"flex"}}>
                                        <div>

                                          <TextField
                                            id={`x-Formula-vector-${name}`}
                                            className="textFieldClass"
                                            rows={1}
                                            value={xFormulaTwo}
                                            label="x value"
                                            onChange={(value) => {
                                              onChange("xFormulaTwo", value);
                                            }}
                                          />
                                        </div>
                                      <div>

                                          <Button  
                                                style={{marginTop:"132%"}}
                                                onClick={()=> onXEvaluateAdd()}>
                                                <img
                                                    src={crossIcon}
                                                    alt="Delete"
                                                    
                                                  />
                                                </Button>
                                      </div>
                                      </div>
                                      </Cell>
                                    
                                      </React.Fragment> : ""}

                      </Grid>
                    </Cell>
                        <Cell size={yEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >

                        <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>
                      
                        <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                          <label
                                  htmlFor={`auto-origin-check-${name}`}
                                  className="vectors-toggle-label"
                                >
                                    <div  style={{ display: "flex",textWrap:"nowrap",fontSize:"12px",marginTop:yEvaluateAdd ? "50%" :"60%"}}>
                                <div >
                                {"Evaluate Y"}
                                </div>
                                {/* <div>
                                  <Button
                                    className="nocqcStyle"
                                    icon
                                    tooltipLabel="Evaluates only the Y component of the answer drawn by the student and ignores the X component."
                                  >
                                    help
                                  </Button>
                                </div> */}
                              </div>   
                                
                          </label>
                            <Toggle
                                  icons={false}
                                  defaultChecked={
                                    evaluate_y ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                  }
                                  width={230}
                              id={`auto-origin-check-${name}`}
                              name="evaluate_y"
                              onChange={(event) => {
                                onChange("evaluate_y", !event.target.checked ? 1 : 0);
                              }}
                              checked={evaluate_y  === 1 ? false :true}
                            />
                          </Cell>
                          <Cell size={yEvaluateAdd ? 2 : !isStaticVector  ? 3 :4} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>    
                              <div style={{display:"flex",height:"100%"}}>
                              <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                                <label
                                    className="vectors-toggle-label"
                                  > 
                                    <div style={{marginTop:yEvaluateAdd ? "66%" :"100%",fontSize:"12px"}}>
                                      Y comp
                                    </div>
                                  </label>
                                  </div>   
                                  <div style={{paddingLeft:"10px"}}>
                                    <SelectField
                                        helpText="Select"
                                        defaultValue={0}
                                        disabled={isStaticVector}
                                        style={{marginTop:yEvaluateAdd ? "33%" :"49%"}}
                                        id={`text-color-answer-${name}`}
                                        onChange={(value) => {
                                          onChange("yEvaluateOption", value);
                                        }}
                                        menuItems={evaluateOptions}
                                        value={isStaticVector ? 0 :yEvaluateOption}
                                      />
                                </div>
                            </div>
                          

                          </Cell>
                          <Cell size={yEvaluateAdd ? 3 : !isStaticVector  ? 4 : 5} style={{borderRight: !isStaticVector  ? "1px solid #9F9F9F" : "",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                            <TextField
                              id={`y-Formula-vector-${name}`}
                              className="textFieldClass"
                              rows={1}
                              value={yFormula}
                              label="y value"
                              onChange={(value) => {
                                onChange("yFormula", value);
                              }}

                            />
                          </Cell>
                          {!yEvaluateAdd  && !isStaticVector ? 
                            <Cell size={2}  style={{margin:"0px"}} >
                              <Button 
                                  style={{ width:"65px",marginLeft:"5px",marginTop:"25%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                    flat 
                                    onClick={()=> onYEvaluateAdd()}>
                                      
                                    Add
                                    another
                                    y
                                    Condition
                                    </Button>
                          </Cell> : !isStaticVector ? 
                            
                            <React.Fragment>
                              <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                <SelectField
                                    helpText="Select"
                                    id={`text-color-answer-${name}`}
                                    onChange={(value) => {
                                      onChange("yQueryOption", value);
                                    }}
                                    style={{marginTop:"25%",paddingRight:"10px"}}
                                    menuItems={QueryOptions}
                                    value={yQueryOption}
                                    defaultValue={0}
                                  />
                            </Cell>
                            <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                  <SelectField
                                  helpText="Select"
                                  style={{marginTop:"35%",marginLeft:"10px"}}
                                    id={`text-color-answer-${name}`}
                                    onChange={(value) => {
                                      onChange("yEvaluateOptionTwo", value);
                                    }}
                                    menuItems={evaluateOptions}
                                    value={yEvaluateOptionTwo}
                                    defaultValue={0}
                                  />
                                
                            </Cell>
                            <Cell size={3} style={{marginLeft:"30px"}}> 
                                <div style={{display:"flex"}}>
                                      <div>

                                      <TextField
                                          id={`y-Formula-vector-${name}`}
                                          className="textFieldClass"
                                          rows={1}
                                          value={yFormulaTwo}
                                          label="y value"
                                          onChange={(value) => {
                                            onChange("yFormulaTwo", value);
                                          }}
                                        />
                                      </div>
                                      <div>

                                            <Button  
                                            style={{marginTop:"132%"}}
                                            onClick={()=> onYEvaluateAdd()}>
                                            <img
                                                src={crossIcon}
                                                alt="Delete"
                                                
                                              />
                                            </Button>
                                      </div>
                                  </div>
                            </Cell>
                          </React.Fragment>
                          : ""}
                        
                        </Grid>
                      </Cell>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Cell size={magEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >
                    <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>

                      <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                          <label
                                    className="vectors-toggle-label"
                                  > 
                                  <div  style={{ display: "flex",textWrap: "wrap" ,fontSize:"12px",marginTop: magEvaluateAdd ? "50%" :"60%"}}>
                                    <div >
                                    Evaluate Magnitude
                                    </div>
                                  </div>   
                            </label>
                              <Toggle
                                    icons={false}
                                    width={230}
                                    defaultChecked={
                                      evaluate_magnitue ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                        }
                                    id={`auto-origin-check-${name}`}
                                    name="evaluate_magnitue"
                                    onChange={(event) => {
                                      onChange("evaluate_magnitue", !event.target.checked ? 1 : 0);
                                    }}
                                    checked={evaluate_magnitue  === 1 ? false :true}
                                  />
                      </Cell>
                      <Cell size={magEvaluateAdd ? 2 :3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                        <div style={{display:"flex",height:"100%"}}>
                            
                            <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                            <label
                                className="vectors-toggle-label"
                              > 
                                <div style={{marginTop:magEvaluateAdd ? "66%" :"100%",fontSize:"10px"}}>
                                  Magnitude
                                </div>
                              </label>
                              </div>   
                            <div>

                              <SelectField
                                  helpText="Select"
                                  defaultValue={0}
                                  style={{marginTop:magEvaluateAdd ? "33%" :"49%"}}
                                  id={`text-color-answer-${name}`}
                                  onChange={(value) => {
                                    onChange("magEvaluateOption", value);
                                  }}
                                  menuItems={evaluateOptions}
                                  value={magEvaluateOption}
                                />
                            </div>
                        </div>

                      </Cell>
                      <Cell size={magEvaluateAdd ? 3 : 4} style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                            <TextField
                              id={`angle-formula-${name}`}
                              className="textFieldClass"
                              rows={1}
                              value={magFormula}
                              label="Magnitude Value"
                              onChange={(value) => {
                                onChange("magFormula", value);
                              }}
                          
                              id="angle-formula-vector"
                            />
                        </Cell>
                        {!magEvaluateAdd ? 
                        <Cell size={2} style={{margin:"0px"}}>
                                  <Button 
                                  className="md-cell--left"
                                  style={{ width: "92px",marginLeft:"3px",marginTop:"15%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                  flat 
                                  onClick={()=> onMagEvaluateAdd()}>
                                    
                                  Add
                                  another
                                  Magnitude
                                  Condition
                                  </Button>
                          </Cell> : 
                          <React.Fragment>

                              <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                <SelectField
                                      helpText="Select"
                                      id={`mag-Formula-vector-${name}`}
                                    className="textFieldClass"
                                    onChange={(value) => {
                                      // variableObj.color = value;
                                      onChange("magQueryOption", value);
                                    }}
                                    style={{marginTop:"25%",paddingRight:"10px"}}
                                    menuItems={QueryOptions}
                                    value={magQueryOption}
                                    defaultValue={0}
                                  />
                            </Cell>
                                <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   

                                    <SelectField
                                        helpText="Select"
                                        style={{marginTop:"35%",marginLeft:"10px"}}
                                        id={`text-color-answer-${name}`}
                                        onChange={(value) => {
                                          // variableObj.color = value;
                                          onChange("magEvaluateOptionTwo", value);
                                        }}
                                        defaultValue={0}
                                        menuItems={evaluateOptions}
                                        value={magEvaluateOptionTwo}
                                      />
                                </Cell>
                              <Cell size={3} style={{marginLeft:"30px"}}>    
                              <div style={{display:"flex"}}>
                                <div>

                                  <TextField
                                    id={`angle-formula-${name}`}
                                    className="textFieldClass"
                                    rows={1}
                                    value={magFormulaTwo}
                                    label="Magnitude Value"
                                    onChange={(value) => {
                                      onChange("magFormulaTwo", value);
                                    }}
                                  
                                    id="angle-formula-vector"
                                  />
                                </div>
                                <div>

                                    <Button  
                                        style={{marginTop:"132%"}}
                                        onClick={()=> onMagEvaluateAdd()}>
                                        <img
                                            src={crossIcon}
                                            alt="Delete"
                                            
                                          />
                                        </Button>
                                </div>
                              </div>
                              </Cell>
                              
                              </React.Fragment>
                          
                
                          }
                    </Grid>

                    </Cell>
                    <Cell size={angEvaluateAdd ? 12 : 6} style={{padding:"0px"}} >
                      <Grid style={{border:"1px solid #9F9F9F",borderRadius:"5px" ,padding:"0px"}}>
                        <Cell size={2} style={{width:"65px" ,borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>

                        <label
                                  className="vectors-toggle-label"
                                > 
                                <div  style={{ display: "flex",textWrap: "wrap" ,fontSize:"12px",marginTop:angEvaluateAdd ? "50%" : "60%"}}>
                                  <div >
                                  Evaluate Angle
                                  </div>
                                </div>   
                          </label>
                            <Toggle
                                  icons={false}
                                  width={230}
                                  defaultChecked={
                                    evaluate_angle ===  1 ? false : true //To cover existing Question, default will be true, 1 will be false
                                      }
                                  id={`auto-origin-check-${name}`}
                                  name="evaluate_angle"
                                  onChange={(event) => {
                                    onChange("evaluate_angle", !event.target.checked ? 1 : 0);
                                  }}
                                  checked={evaluate_angle === 1 ? false :true}
                                />
                        </Cell>

                        <Cell size={angEvaluateAdd ? 2 :3} style={{padding:"0px",margin:"0px",marginRight:"8px",marginTop:"2%"}}>   
                        <div style={{display:"flex",height:"100%"}}>
                            
                            <div  style={{ display: "flex",textWrap:"wrap",fontSize:"12px",paddingRight:"5px"}}>
                            <label
                                className="vectors-toggle-label"
                              > 
                                <div style={{marginTop: angEvaluateAdd ? "66%" :"100%",fontSize:"12px"}}>
                                  Angle
                                </div>
                              </label>
                              </div>   
                            <div>

                              <SelectField
                                  helpText="Select"
                                  defaultValue={0}
                                  style={{marginTop:angEvaluateAdd ? "33%" :"49%"}}
                                  id={`text-color-answer-${name}`}
                                  onChange={(value) => {
                                    onChange("angEvaluateOption", value);
                                  }}
                                  menuItems={evaluateOptions}
                                  value={angEvaluateOption}
                                />
                            </div>
                        </div>

                      </Cell>
                      <Cell size={angEvaluateAdd ? 3 :4 } style={{borderRight:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px",marginRight:"5px"}}>    
                            <TextField
                              id={`mag-formula-${name}`}
                              className="textFieldClass"
                              rows={1}
                              value={angleFormula}
                              label="Angle Value"
                              onChange={(value) => {
                                onChange("angleFormula", value);
                              }}
                          
                            />
                        </Cell>
                        {!angEvaluateAdd ?  <Cell size={2} style={{margin:"0px"}}>
                                  <Button 
                                  className="md-cell--left"
                                  style={{ width: "92px",marginLeft:"3px",marginTop:"15%",background:"#868E92",height:"80%",borderRadius:"5px",color:"white"}} 
                                  flat 
                                  onClick={()=> onAngEvaluateAdd()}>
                                    
                                  Add
                                  another
                                  Angle
                                  Condition
                                  </Button>
                          </Cell> : 
                                  <React.Fragment>

                                  <Cell size={1} style={{marginLeft:"10px",marginRight:"20px"}}>   
                                    <SelectField
                                          helpText="Select"
                                          id={`mag-Formula-vector-${name}`}
                                        className="textFieldClass"
                                        onChange={(value) => {
                                          // variableObj.color = value;
                                          onChange("angQueryOption", value);
                                        }}
                                        style={{marginTop:"25%",paddingRight:"10px"}}
                                        menuItems={QueryOptions}
                                        value={angQueryOption}
                                        defaultValue={0}
                                      />
                                </Cell>
                                    <Cell size={1} style={{borderLeft:"1px solid #9F9F9F",marginTop:"0px",marginBottom:"0px"}}>   
      
                                        <SelectField
                                            helpText="Select"
                                            style={{marginTop:"35%",marginLeft:"10px"}}
                                            id={`text-color-answer-${name}`}
                                            onChange={(value) => {
                                              // variableObj.color = value;
                                              onChange("angEvaluateOptionTwo", value);
                                            }}
                                            defaultValue={0}
                                            menuItems={evaluateOptions}
                                            value={angEvaluateOptionTwo}
                                          />
                                    </Cell>
                                  <Cell size={3} style={{marginLeft:"30px"}}>    
                                  <div style={{display:"flex"}}>
                                    <div>
      
                                      <TextField
                                        id={`angle-formula-${name}`}
                                        className="textFieldClass"
                                        rows={1}
                                        value={angFormulaTwo}
                                        label="Angle Value"
                                        onChange={(value) => {
                                          onChange("angFormulaTwo", value);
                                        }}
                                    
                                        id="angle-formula-vector"
                                      />
                                    </div>
                                    <div>
      
                                        <Button  
                                            style={{marginTop:"132%"}}
                                            onClick={()=> onAngEvaluateAdd()}>
                                            <img
                                                src={crossIcon}
                                                alt="Delete"
                                                
                                              />
                                            </Button>
                                    </div>
                                  </div>
                                  </Cell>
                                  
                                  </React.Fragment>
                          }
                      </Grid>
                    </Cell>
                  </React.Fragment>
                )}
              
            
             </React.Fragment> :
              <React.Fragment>
              <Cell size={23}>
              <Grid style={{width:"426px"}}></Grid>
              </Cell>
              </React.Fragment>
            }
           



            </Grid>
      </CardText>
    </div>
  );
};

export default DrawVectorAnswerOption;
